import { render } from "./estados.vue?vue&type=template&id=dbc551a4&scoped=true"
import script from "./estados.vue?vue&type=script&lang=js"
export * from "./estados.vue?vue&type=script&lang=js"

import "./estados.vue?vue&type=style&index=0&id=dbc551a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbc551a4"]])

export default __exports__